<!-- Intro Header -->
<header class="sdg-status">
  <div class="intro-body">
    <div class="container">
      <div class="row" appDynamicDirection>
        <div class="col-md-12">
          <div class="row">
            <div class="col-sm-6 title">
              <h4 class="page-heading">Water-Related Sustainable Development Goals</h4>
              <h2 class="intro-text" i18n>Finance - Resources</h2>
            </div>
            <div class="col-sm-6">
              <a class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center " style="margin-bottom: 15px; background: #1f487c;">
                <span i18n>Resources</span>
              </a>
              <a (click) = "quesBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center " style="margin-bottom: 15px;">
                <span i18n>Questionnaire</span>
              </a>
              <a (click) = "dataBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center" style="margin-bottom: 15px;">
                <span i18n>Data</span>
              </a>
              <a (click) = "reportBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center" style="margin-bottom: 15px;">
                <span i18n>Reporting</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
<section class="content-section">
    <mat-table #table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="column1">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Tool/Resource </mat-header-cell>
              <mat-cell *matCellDef="let element">  {{element.column1}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="column2">
              <mat-header-cell *matHeaderCellDef> Link to tool/resource </mat-header-cell>
              <mat-cell *matCellDef="let element"> <a href= {{element.column2}}>Link</a> </mat-cell>
            </ng-container>

            <ng-container matColumnDef="column3">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Data sources  </mat-header-cell>
              <mat-cell *matCellDef="let element">  {{element.column3}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="column4">
              <mat-header-cell *matHeaderCellDef> Link to data source </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.column4}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="column5">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Indicator number in tool/resource</mat-header-cell>
              <mat-cell *matCellDef="let element">  {{element.column5}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="column6">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Used in SDG-PSS</mat-header-cell>
              <mat-cell *matCellDef="let element">  {{element.column6}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="column7">
              <mat-header-cell *matHeaderCellDef> Indicator title </mat-header-cell>
              <mat-cell *matCellDef="let element">  {{element.column7}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="column8">
              <mat-header-cell *matHeaderCellDef> Measure/Question/Sub-indicator</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.column8}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="column9">
                <mat-header-cell *matHeaderCellDef> Data description</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.column9}} </mat-cell>
              </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
          </mat-table>
</section>



// WEBPACK FOOTER //
// ./src/app/sdg/finance/finance.component.html